const isPurchaseResultPage = () => {
  return (
    window.location.pathname.includes("purchase-result") ||
    window.location.pathname.includes("purchase-complete") ||
    window.location.pathname.includes("purchase-downgrade-success")
  );
};

export default isPurchaseResultPage;
